// Imports
import React, { useState } from "react"
import { Button } from "@molecules"
import { urls } from "@api"
import { Done } from "@icons"

export const Subsciption = ({ text }) => {
  const [email, setEmail] = useState("")
  const [subscribed, setSubscribed] = useState(false)

  // Form change handlers
  const handleEmailChange = (e) => setEmail(e.target.value)

  // Handle user subscribe
  const handleSubscribe = async (e) => {
    e.preventDefault()

    if (email) {
      fetch(`${urls.mcSubscribe}?email=${email}`)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          if(res.id) setSubscribed(true)
        })
        .catch((err) => console.log(err))
    }
  }
  return (
    <form onSubmit={handleSubscribe}>
      <div className="subscription">
        {!subscribed ? (
          <div className="subscription-action">
            <input
              className="input"
              value={email}
              type="text"
              placeholder="E-mail cím"
              onChange={handleEmailChange}
              required
            />
            <Button iconPosition="" text="Feliratkozás" rounded type="submit" />
          </div>
        ) : (
          <div className="subscription-success">
            <Done />
            <p className="bold">Sikeres feliratkozás!</p>
          </div>
        )}
        <div className="subscription-text">
          <p>{text}</p>
        </div>
      </div>
    </form>
  )
}
